import { Error } from '@cognitiv/cicada-ui';
import { v4 as uuidv4 } from 'uuid';

export function handleTimeoutConversion(input: string) {
  let timeout = 0;
  if (+input === 0 || input) {
    const [hours, hour, minutes, minute, seconds, second] = input.split('');
    timeout += (+hours || 0) * 36000;
    timeout += (+hour || 0) * 3600;
    timeout += (+minutes || 0) * 600;
    timeout += (+minute || 0) * 60;
    timeout += Number(seconds || 0) * 10 + Number(second || 0);
  }

  return timeout;
}

export function handleSideMenu(pathname: string) {
  switch (true) {
    case pathname.includes('/jobs'):
      return 'jobs';
    case pathname.includes('/batches'):
      return 'batches';
    case pathname.includes('/job_definitions'):
      return 'job_definitions';
    case pathname.includes('/batch_definitions'):
      return 'batch_definitions';
    case pathname.includes('/scheduled_batches'):
      return 'scheduled_batches';
    case pathname.includes('/admin'):
      return 'projects';
    default:
      return 'projects';
  }
}

export function passwordScore(password: string) {
  const matchedCase = [];
  matchedCase.push('[$@$!%*#?&]'); // special character
  matchedCase.push('[A-Z]'); // uppercase
  matchedCase.push('[0-9]'); // numbers
  matchedCase.push('[a-z]'); // lowercase

  let score = 0;

  if (password.length > 5) {
    score++;
  }

  matchedCase.forEach((r) => {
    if (new RegExp(r).test(password)) {
      score++;
    }
  });

  return score;
}

export const createParameters = <
  T extends Array<{
    parameter_name: string;
    delete: boolean;
    parameter_direction_id: number | null;
    parameter_method_id: number | null;
    is_required: boolean;
    is_encrypted: boolean;
    parameter_value: string;
    description: string;
    command_line_prefix: string;
    command_line_assignment_char: string;
    command_line_escaped: boolean;
    command_line_ignore_name: boolean;
    reference_type_id: number | null;
    reference_id: number | null;
    reference_parameter_name: string | null;
  }>,
>(
  parameters: T,
) =>
  parameters
    .filter((p) => !!p.parameter_name || p.delete)
    .map((p) => ({
      parameter_name: p.parameter_name,
      parameter_direction_id: p.parameter_direction_id,
      parameter_method_id: p.parameter_method_id,
      is_required: p.is_required,
      is_encrypted: p.is_encrypted,
      parameter_value: p.parameter_value,
      description: p.description,
      command_line_prefix: p.command_line_prefix,
      command_line_assignment_char: p.command_line_assignment_char,
      command_line_escaped: p.command_line_escaped,
      command_line_ignore_name: p.command_line_ignore_name,
      reference_type_id: p.reference_type_id,
      reference_id: p.reference_id,
      reference_parameter_name: p.reference_parameter_name,
    }));

export const getEntityWidth = (name = '') => {
  const length = String(name).length || 0;
  switch (true) {
    case length >= 45:
      return length * 7.5;
    case length >= 35:
      return length * 8.5 - 2;
    case length >= 25:
      return length * 8.5 - 5;
    case length >= 12:
      return length * 8.5;
    case length < 12:
      return length * 8.5 + 20;
    default:
      return 65;
  }
};

export const week_days = [
  { day: 'S', id: uuidv4() },
  { day: 'M', id: uuidv4() },
  { day: 'T', id: uuidv4() },
  { day: 'W', id: uuidv4() },
  { day: 'T', id: uuidv4() },
  { day: 'F', id: uuidv4() },
  { day: 'S', id: uuidv4() },
];

export const parseDockerImg = (docker: string) => {
  const res = {
    registry: '-',
    repository: '-',
    tag: '-',
  };

  const [withoutProtocol, tag] = docker.split(':');
  const [registry, ...repositoryParts] = withoutProtocol.replace(/^https?:\/\//, '').split('/');

  if (tag) {
    res.tag = tag;
  }

  if (repositoryParts.length > 0) {
    res.repository = repositoryParts.join('/');
  } else if (registry) {
    res.repository = registry;
    res.registry = '-';
  } else {
    return res;
  }

  if (registry) {
    res.registry = registry;
  }

  return res;
};

export const getFormWarnings = (errors: Error[]) => {
  return errors.map(({ error }) => error);
};
